import React, { useState, useEffect } from 'react';
import { translations } from './Translation';

function Team({ isOpen, shop }) {
  const [selectedBarber, setSelectedBarber] = useState(null);
  const [slideIndex, setSlideIndex] = useState(null);
  const [language, setLanguage] = useState(localStorage.getItem('elitecut_lang') || 'en');
  const t = translations[language] || translations.en;

  useEffect(() => {
    const handleStorage = () => setLanguage(localStorage.getItem('elitecut_lang') || 'en');
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (slideIndex === null || !selectedBarber) return;
      if (e.key === 'ArrowRight') nextPhoto(e);
      if (e.key === 'ArrowLeft') prevPhoto(e);
      if (e.key === 'Escape') setSlideIndex(null);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [slideIndex, selectedBarber]);

  const nextPhoto = (e) => {
    if (e) e.stopPropagation();
    setSlideIndex((prev) => (prev === selectedBarber.portfolio.length - 1 ? 0 : prev + 1));
  };

  const prevPhoto = (e) => {
    if (e) e.stopPropagation();
    setSlideIndex((prev) => (prev === 0 ? selectedBarber.portfolio.length - 1 : prev - 1));
  };

  if (!isOpen || !shop) return null;

  const barbers = shop.barbers || [];

  return (
    <div className="team-section" style={{ padding: '40px' }}>
      <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>{t.ourPros}</h2>
      
      {barbers.length === 0 ? (
        <p style={{ color: '#64748b' }}>{t.noBarbersYet}</p>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
          {barbers.map((barber) => (
            <div key={barber.id} style={{ border: '1px solid #e2e8f0', borderRadius: '16px', padding: '20px', textAlign: 'center', background: 'white', position: 'relative' }}>
              
              {barber.image ? (
                <img src={barber.image} alt={barber.name} style={{ width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover', marginBottom: '15px' }} />
              ) : (
                <div style={{ fontSize: '50px', marginBottom: '10px' }}>👤</div>
              )}
              
              <h3 style={{ margin: '0 0 5px 0', fontSize: '18px' }}>{barber.name}</h3>
              <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>{barber.role || 'Professional'}</p>
              
              <div style={{ marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #f1f5f9' }}>
               <div style={{ marginTop: '10px', marginBottom: '15px', width: '100%', textAlign: 'left' }}>
                  {barber.services && barber.services.length > 0 ? (
                    barber.services.map((svc, idx) => (
                      <div 
                        key={idx} 
                        style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center',
                          fontSize: '13px', 
                          padding: '6px 0', 
                          borderBottom: '1px solid #f1f5f9' 
                        }}
                      >
                        <span style={{ fontWeight: '500', color: '#0f172a' }}>{svc.name}</span>
                        <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{svc.price}</span>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: 'center', fontSize: '13px', color: '#64748b' }}>
                      No services added
                    </div>
                  )}
                </div>

                {barber.portfolio && barber.portfolio.length > 0 && (
                  <div 
                    onClick={() => setSelectedBarber(barber)}
                    style={{ cursor: 'pointer', background: '#f8fafc', padding: '10px', borderRadius: '12px', border: '1px solid #e2e8f0', transition: '0.2s' }}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#3b82f6'}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#e2e8f0'}
                  >
                    <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '5px', scrollbarWidth: 'none' }}>
                      {barber.portfolio.map((img, i) => (
                        <img key={i} src={img} alt="Haircut portfolio" style={{ width: '60px', height: '60px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0 }} />
                      ))}
                    </div>
                    <span style={{ fontSize: '11px', color: '#0f172a', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', marginTop: '5px' }}>
                      {t.tapLookbook}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {selectedBarber && (
        <div className="login-modal-overlay" onClick={() => setSelectedBarber(null)} style={{ zIndex: 9999 }}>
          <div className="login-modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', padding: '0', overflow: 'hidden', background: '#0f172a', border: '1px solid #334155' }}>
            <button className="modal-close-btn" onClick={() => setSelectedBarber(null)} style={{ background: 'rgba(255,255,255,0.1)', color: 'white', zIndex: 10, top: '15px', right: '15px' }}>✕</button>
            <div style={{ padding: '40px 30px', textAlign: 'center', background: 'linear-gradient(135deg, #1e293b, #0f172a)', borderBottom: '1px solid #334155' }}>
              {selectedBarber.image ? <img src={selectedBarber.image} alt={selectedBarber.name} style={{ width: '100px', height: '100px', borderRadius: '50%', objectFit: 'cover', border: '3px solid #3b82f6', marginBottom: '15px', boxShadow: '0 0 20px rgba(59,130,246,0.3)' }} /> : <div style={{ fontSize: '60px' }}>👤</div>}
              <h2 style={{ color: 'white', margin: '0 0 8px 0', fontSize: '28px' }}>{selectedBarber.name}'s {t.lookbookTitle}</h2>
              <p style={{ color: '#94a3b8', margin: 0, fontSize: '15px' }}>{t.lookbookSub}</p>
            </div>
            <div style={{ padding: '30px', background: '#0f172a', maxHeight: '55vh', overflowY: 'auto' }}>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '20px' }}>
                {selectedBarber.portfolio?.map((img, i) => (
                  <div key={i} style={{ position: 'relative', paddingTop: '100%', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 10px 20px rgba(0,0,0,0.4)', border: '1px solid #1e293b' }}>
                    <img src={img} alt={`Lookbook cut ${i}`} onClick={() => setSlideIndex(i)} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.3s ease', cursor: 'pointer' }} onMouseOver={e => e.target.style.transform = 'scale(1.05)'} onMouseOut={e => e.target.style.transform = 'scale(1)'} />
                  </div>
                ))}
              </div>
            </div>

            {slideIndex !== null && (
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(10px)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} onClick={() => setSlideIndex(null)}>
                <button onClick={(e) => { e.stopPropagation(); setSlideIndex(null); }} style={{ position: 'absolute', top: '30px', right: '40px', background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', fontSize: '24px', width: '50px', height: '50px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
                <button onClick={prevPhoto} style={{ position: 'absolute', left: '40px', background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', fontSize: '30px', width: '60px', height: '60px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>❮</button>
                <img src={selectedBarber.portfolio[slideIndex]} alt="Slide" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '85vh', maxWidth: '85vw', objectFit: 'contain', borderRadius: '12px', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }} />
                <button onClick={nextPhoto} style={{ position: 'absolute', right: '40px', background: 'rgba(255,255,255,0.1)', border: 'none', color: 'white', fontSize: '30px', width: '60px', height: '60px', borderRadius: '50%', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>❯</button>
                <div style={{ position: 'absolute', bottom: '30px', color: '#cbd5e1', fontSize: '16px', fontWeight: 'bold', background: 'rgba(0,0,0,0.5)', padding: '8px 20px', borderRadius: '20px' }}>
                  {slideIndex + 1} / {selectedBarber.portfolio.length}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Team;